import React, { useEffect, useState } from "react";
import "../../Restrictions/RestrictionsBanner/RestrictionsBanner.css";
import "../../Coporate-travel-management/CorporateBanner/CorporateBanner.css";
import BannerWrapper from "../../../commonComponents/BannerWrapper";
import Heading from "../../../utls/Heading";
import HeadingH1 from "../../../utls/HeadingH1";
const AboutTourism = ({ onLoad }) => {
  const [useHighRes, setUseHighRes] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);


  // Check network speed and update state accordingly.
  useEffect(() => {
    if (navigator.connection) {
      const connection = navigator.connection;
      // You can adjust the threshold as needed.
      if (connection.downlink && connection.downlink > 2) {
        setUseHighRes(true);
      }
    } else {
      // If navigator.connection is not available, assume a fast connection.
      setUseHighRes(true);
    }
  }, []);

  // Immediately unlock the rest of the page as soon as the banner mounts after delay of 0.5s.
  useEffect(() => {
    if (!useHighRes && onLoad) {
      const timer = setTimeout(() => {
        onLoad();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [useHighRes, onLoad]);


  // Callback for when the index 0 image loads on high-speed connections.
  const handleImageLoad = () => {
    if (useHighRes) {
      setImageLoaded(true);
      if (onLoad) {
        onLoad();
      }
    }
  };
  return (
    <div>
      <BannerWrapper onLoad={onLoad}>
        <div className="container-fluid ctm-banner position-relative" style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}>
          <img
            src="https://blueberrywebsites.azureedge.net/bbt/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/Tourism.jpg"
            alt="Contact Banner"
            className="w-100"
            // For high-speed, use eager loading; for low-speed, lazy loading.
            loading={useHighRes ? "eager" : "lazy"}
            // Attach the onLoad handler only for high-speed connections.
            onLoad={useHighRes ? handleImageLoad : undefined}
            fetchpriority={useHighRes ? "high" : "auto"}
          />
          <div className="ctm-text position-absolute text-white  mt-3">
            <p className="fs4 text-uppercase busy grotesk-headings">GLOBAL TRAVEL</p>
            <HeadingH1 className="banner-headings w-100">
              Navigate Travel <br />
              with Confidence
            </HeadingH1>
          </div>
        </div>
      </BannerWrapper>
      {/* .......................after banner section........................... */}
      <div className="container why-staying px-md-5">
        <div className="row">
          <div className="col-md-12">
            <Heading className="customheadings">
              <span>We </span>Are Blueberry Travel
            </Heading>
            <p className="mt-3">
              Started this journey from a single idea: ‘to give travelers the privilege of instant corporate travel bookings, providing complete customized travel solutions.’ Blueberry Travel was discovered in 2013 and has since expanded significantly to become the most reputable and trustworthy business travel company in the world, crafting extraordinary travel experiences that are a blend of adventure, luxury, and culture.
            </p>
            <p className="mt-3">
              Traveling to just work during your business meeting when you can experience more? At Blueberry Travel, we don’t just plan trips; we curate experiences that inspire, excite, and leave lasting memories. Be it a luxury retreat, a heart-racing safari, or a deep exploration of different cultural wonders, we craft journeys that go beyond the ordinary. With a strong presence across Africa and beyond, we specialize in personalized holiday packages, private tours, and adventure getaways, perfect for both leisure and corporate travelers. You dream it; we make it happen effortlessly.
            </p>
          </div>
        </div>

        <div className="restrictionNeedRow  gap-md-3">
          <div className="col-lg-6">
            <div className="need-frame1">
              <div className="frame1-txt d-flex flex-column justify-content-start align-items-start">
                <Heading level={2} className="headings">Where do we come from?</Heading>
                <p>
                  BBT was founded in 2013 to meet the growing demand for DMC services in Africa. Currently, we served over 150,000 guests globally last year.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="need-frame1">
              <div className="frame1-txt d-flex flex-column justify-content-start align-items-start">
                <Heading level={2} className="headings">Where do we operate?</Heading>
                <p>
                  India is what we call home, but our reach goes far beyond. With a presence in 30+ African countries, we are preparing itineraries for diverse destinations.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="restrictionNeedRow  gap-md-3">
          <div className="col-lg-6">
            <div className="need-frame1">
              <div className="frame1-txt d-flex flex-column justify-content-start align-items-start">
                <Heading level={2} className="headings">What we do?</Heading>
                <p>
                  Travel isn’t just about reaching a destination; it's about experiencing the journey. From crafting customized holidays to corporate travel, count us in!
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="need-frame1">
              <div className="frame1-txt d-flex flex-column justify-content-start align-items-start">
                <Heading level={2} className="headings">Innovation, Expertise & Excellence</Heading>
                <p>
                  We believe true success lies in the perfect blend of partnership and cutting-edge technology. From industry expertise to innovative solutions, let us be a part of it.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutTourism;
